// Packages
import { useState, useEffect, React } from "react";
import { Link, useParams } from "react-router-dom";
// import moment from "moment";
import PropTypes from "prop-types";

// Material Ui
// import CssBaseline from "@material-ui/core/CssBaseline";
import { Typography } from "@material-ui/core";
// import MaterialTable from "material-table";
import { makeStyles } from "@material-ui/core/styles";
// import AppBar from "@material-ui/core/AppBar";
// import Tabs from "@material-ui/core/Tabs";
// import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
// import { Animation } from "@devexpress/dx-react-chart";
// import vdoIcon from "../../assets/images/vdoIcon.png";
// import imgIcon from "../../assets/images/imgIcon.png";
// import otherIcon from "../../assets/images/otherIcon.png";
// import documentIcon from "../../assets/images/documentIcon.png";
// import Popover from "@material-ui/core/Popover";
import Toolbar from "@material-ui/core/Toolbar";
import backarrow from "../../assets/images/back-arrow.png";
// Styles
import "./schoolAdmin.css";

// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";
// import ElevationScroll from "../schoolAdminPortal/ElevationScroll";
// Assets
// import settingIcon from "../../assets/images/settingIcon.png";
import editIcon from "../../assets/images/editIcon.png";
import schoolLogo from "../../assets/images/default_school.png";
// import backArrow from "../../assets/images/backArrow.png";
// import Delete from "../../assets/images/Delete.png";
// import Reset from "../../assets/images/Reset.png";
// import Activete from "../../assets/images/Activate.png";
// import { Chart, PieSeries } from "@devexpress/dx-react-chart-material-ui";

// Services
import userService from "../../services/user.service";
import { getFromLocalStorage } from "../../utils/webStorage";
import PageNotFound from "../../routes/PageNotFound";
import PageNotFoundPage from "../../Common/PageNotFoundPage";

// Utils

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
const data = [
  {
    INVOICEID: "R1000000000001",
    DATETIME: "2020-01-01 | 12:05 PM",
    PAYMENTMETHOD: "California",
    STATUS: "+44-8927471190",
    AMOUNT: "Active",
  },
  {
    INVOICEID: "R1000000000001",
    DATETIME: "2020-01-01 | 12:05 PM",
    PAYMENTMETHOD: "California",
    STATUS: "+44-8927471190",
    AMOUNT: "Active",
  },
  {
    INVOICEID: "R1000000000001",
    DATETIME: "2020-01-01 | 12:05 PM",
    PAYMENTMETHOD: "California",
    STATUS: "+44-8927471190",
    AMOUNT: "Active",
  },
  {
    INVOICEID: "R1000000000001",
    DATETIME: "2020-01-01 | 12:05 PM",
    PAYMENTMETHOD: "California",
    STATUS: "+44-8927471190",
    AMOUNT: "Active",
  },
  {
    INVOICEID: "R1000000000001",
    DATETIME: "2020-01-01 | 12:05 PM",
    PAYMENTMETHOD: "California",
    STATUS: "+44-8927471190",
    AMOUNT: "Active",
  },
];
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const chartdata = [
  { storageType: "free", area: 12 },
  { storageType: "occupied", area: 7 },
];

const columns = [
  { title: "id", field: "id", hidden: true },
  { title: "INVOICE ID", field: "INVOICEID" },
  {
    title: "DATE / TIME",
    field: "DATETIME",
    type: "date",
    format: "dd/MM/yyyy : hh:mm",
  },
  { title: "PAYMENT METHOD", field: "PAYMENTMETHOD" },
  { title: "STATUS", field: "STATUS" },
  { title: "AMOUNT", field: "AMOUNT" },
  {
    render: (rowData) => (
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
      >
        <MoreVertIcon />
      </IconButton>
    ),
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  typography: {
    padding: theme.spacing(2),
  },
}));

function SchoolNameScreen() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState(0);
  const [schoolData, setSchoolData] = useState([]);
  const [imageLogo, setImageLogo] = useState(null);
  const [schoolStatus, setSchoolstatus] = useState(false);
  const [getschoolStatus, setGetSchoolstatus] = useState(false);
  const [adminRole, setAdminRole] = useState("");
  const params = useParams();

  const school = document.getElementById("School");
  if (school) {
    school.classList.add("active");
  }

  useEffect(() => {
    var adminRole = getFromLocalStorage("loginRole");
    setAdminRole(adminRole);
    userService
      .getSchoolDetails(params.schoolId)
      .then((response) => {
        let arr = [];
        arr.push(response.data.data);
        setSchoolData(arr);
        setGetSchoolstatus(response.data.data.status);
        if (response.data.data.uploadedLogo != null) {
          let imageFilepath = response.data.data.uploadedLogo.filePath;
          setImageLogo(imageFilepath);
        } else {
          let imageFilepath = null;
          setImageLogo(imageFilepath);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }, [params.schoolId]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const statusCheck = () => {
    setSchoolstatus(true);
    userService
      .getStatusSchool(params.schoolId, schoolStatus)
      .then((response) => {
        if (response.data.success == true) {
          alert("School activated successfully.");
          this.useEffect();
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const statusCheckFalse = () => {
    setSchoolstatus(false);
    userService
      .getStatusSchool(params.schoolId, schoolStatus)
      .then((response) => {
        if (response.data.success == true) {
          alert("School activated successfully.");
          this.useEffect();
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const openDialogRemoved = () => {
    // this.setState({ openRemove: !this.state.openRemove });
  };
  const closeDialogRemoved = () => {
    // this.setState({ openRemove: !this.state.openRemove });
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      {adminRole == "SCHOOL ADMIN" ? (
        <div>
          <SchoolAdminDashboard />

          <div className=" p-0">
            <div className="top-strip">
              <div className="container">
                <div className="col-md-12 col-lg-12">
                  <div className="clear100"></div>
                </div>
                <div className="addSchool-innerHeader">
                  <Toolbar>
                    <div className="col-8">
                      <Link to="./schooladmindata">
                        <span className="backbtn">
                          <img src={backarrow} alt="" />
                        </span>
                      </Link>
                      <label className="txt-blue bold fs-18">
                        BACK TO FEEDS
                      </label>
                    </div>
                    <div className="text-right col-4">
                      <img src={editIcon} className="mr-2 fs-14" alt="" />
                    </div>
                  </Toolbar>
                </div>
                <div className="row m-0 margin-80">
                  <div className="col-1 plr txt-center ">
                    {imageLogo && (
                      <img
                        className="h-100 img-fluid"
                        src={imageLogo}
                        alt="PIC"
                      />
                    )}

                    {!imageLogo && (
                      <img className=" img-fluid" src={schoolLogo} alt="PIC" />
                    )}
                  </div>
                  <div className="col-6">
                    {/* <div className="clear20"></div> */}

                    <p className="txt-black fs-30 semi-bold">
                      Alabama Crimson Tide football
                    </p>
                    <p className="txt-blue fs-18 medium addrtxt">
                      231/4A, Viman Nagar Rd, Clover Park, Viman Nagar, Pune,
                      Maharashtra 411014
                    </p>
                  </div>
                </div>
              </div>
              <div className="container pading-top pt-4 pl-4 pb-0">
                <div class="col-6 white-card plr">
                  <div class="clear10"></div>
                  <div class="row ">
                    <div class="col-4 fmlabel">
                      <label className="fs-18 medium">School Type</label>
                    </div>
                    <div class="col-8">
                      <label className="fs-18 semi-bold black">
                        Charter school
                      </label>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-4 fmlabel">
                      <label className="fs-18 medium">Owner Name</label>
                    </div>
                    <div class="col-8">
                      <label className="fs-18 semi-bold black">
                        Nick Saban
                      </label>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-4 fmlabel">
                      <label className="fs-18 medium">State</label>
                    </div>
                    <div class="col-8">
                      <label className="fs-18 semi-bold black">
                        California
                      </label>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-4 fmlabel">
                      <label className="fs-18 medium">Country</label>
                    </div>
                    <div class="col-8">
                      <label className="fs-18 semi-bold black">USA</label>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-4 fmlabel">
                      <label className="fs-18 medium">Country</label>
                    </div>
                    <div class="col-8">
                      <label className="fs-18 semi-bold black">
                        Nick Saban
                      </label>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-4 fmlabel">
                      <label className="fs-18 medium">Address</label>
                    </div>
                    <div class="col-8">
                      <label className="fs-18 semi-bold black">
                        Address line here
                      </label>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-4 fmlabel">
                      <label className="fs-18 medium">Plan</label>
                    </div>
                    <div class="col-8">
                      <label className="fs-18 semi-bold black">Plan2</label>
                    </div>
                  </div>
                  <div class="clear10"></div>
                </div>
              </div>

              <div className="container pt-2 pl-4 ">
                <div class="col-6 white-card plr">
                  <div class="clear10"></div>
                  <div class="row">
                    <label class="fs-18 semi-bold">OTHER DETAILS</label>
                  </div>
                  <div class="clear10"></div>
                  <div class="row ">
                    <div class="col-4 fmlabel">
                      <label className="fs-18 medium">Date Joined</label>
                    </div>
                    <div class="col-8">
                      <label className="fs-18 semi-bold black">
                        08 Oct 2021
                      </label>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-4 fmlabel">
                      <label className="fs-18 medium">Email</label>
                    </div>
                    <div class="col-8">
                      <label className="fs-18 semi-bold black">
                        connect@alabamasports.com
                      </label>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-4 fmlabel">
                      <label className="fs-18 medium">Contact</label>
                    </div>
                    <div class="col-8">
                      <label className="fs-18 semi-bold black">
                        +01-66544562
                      </label>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-4 fmlabel">
                      <label className="fs-18 medium">Sports</label>
                    </div>
                    <div class="col-8">
                      <label className="fs-18 semi-bold black">
                        American Football
                      </label>
                    </div>
                  </div>

                  <div class="clear10"></div>
                </div>
              </div>

              <div className="container pt-2 pl-4 ">
                <div class="col-6 white-card plr">
                  <div class="clear10"></div>
                  <div class="row">
                    <label class="fs-18 semi-bold">LEGAL DOCUMENTS</label>
                  </div>
                  <div class="clear10"></div>
                  <div class="row ">
                    <div class="col-4 fmlabel">
                      <label className="fs-18 medium">Documents</label>
                    </div>
                    <div class="col-8">
                      <label className="fs-18 semi-bold royal-blue cp">
                        <u>File.pdf</u>
                      </label>
                    </div>
                  </div>

                  <div class="clear10"></div>
                </div>
              </div>

              <div class="clear50"></div>
            </div>
          </div>
        </div>
      ) : (
        <PageNotFoundPage />
      )}
    </div>
  );
}

export default SchoolNameScreen;
